export default {
  searchText(state) {
    return state.searchText;
  },
  listOptions(state) {
    return state.listOptions;
  },
  stringFilter(state) {
    if (!state.searchText) {
      return '';
    }
    return `(descricao like '%${state.searchText.toLowerCase()}%' or codigoInterno like '%${state.searchText.toLowerCase()}%')`;
  },
};
